<template>
  <div></div>
</template>

<script>
export default {
  name: "redirect-act-index",
  mounted() {
    this.$router.push({path: 'act-index', query: {id: '4'}});
  }
}
</script>

<style scoped>

</style>